
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection",
      function () {
        return require("private-next-pages/collection/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection"])
      });
    }
  